(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/bankid/use-bankid-poll-status.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/bankid/use-bankid-poll-status.js');

'use strict';

const {
  logger
} = svs.playerLogin;
const {
  cancelCustomerLoginAsync,
  getBankIdAutoStartTokenAsync,
  pollCustomerLoginAsync
} = svs.playerLogin.bankid.BankidService;
const {
  bankidProgressStatus,
  route
} = svs.playerLogin.constants;
const {
  handleShowBankIdErrorCode
} = svs.playerLogin.bankid.BankIdErrorHandling;
const {
  useHistory
} = ReactRouterDOM;
const {
  storeCustomerType,
  saveRefForGUITest
} = svs.playerLogin.sharedComponents.sharedUtils;
const {
  handleShowError,
  handleShowErrorNoFlash
} = svs.playerLogin.sharedComponents.Dialogs;
const {
  bankIdAutostartTokenChangenAction,
  setIsBankidOnThisDevice
} = svs.playerLogin.store.playerloginreactactions;
const isBankId = true;
const {
  useCheckPlayerAfterSession
} = svs.playerLogin.sharedComponents;
const {
  useUrlHelper
} = svs.playerLogin.sharedComponents;

const useBankIdPollStatus = (isQrCode, isLogin, ssn, autoStartToken) => {
  logger.debug('*** init useBankIdPollStatus');
  logger.debug("*** autoStartToken: ".concat(autoStartToken));
  const dispatch = ReactRedux.useDispatch();
  const isReturnNewCustomer = ReactRedux.useSelector(state => state.playerloginreact.isReturnNewCustomer);
  const {
    returnUrl,
    isTestEnvironment
  } = ReactRedux.useSelector(state => state.playerloginreact);
  const {
    navigateToCancelUrl,
    getBankIdAppUrl
  } = useUrlHelper();
  const isSsn = ssn && ssn.length > 0;
  const isSameDevice = !isQrCode && !isSsn;
  const history = useHistory();
  const autoStartTokenRef = React.useRef('');
  const qrCodeRetries = React.useRef(5);
  const [appUrl, setAppUrl] = React.useState('');
  const [qrCode, setQrCode] = React.useState('');
  const networkRetries = React.useRef(2);
  const isUnmountingRef = React.useRef(false);
  const timeOutRef = React.useRef(false);
  const [backendStatus, setBackendStatus] = React.useState(bankidProgressStatus.BEFORE_POLL);
  const checkPlayerAfterSessionAsync = useCheckPlayerAfterSession();
  const isBankidOnThisDevice = ReactRedux.useSelector(state => state.playerloginreact.isBankidOnThisDevice);

  const initBankIdcodeAsync = async () => {
    try {
      const response = await getBankIdAutoStartTokenAsync(ssn);
      const autoStartTokenLocal = response.autoStartToken;
      const qrDataLocal = response.qrData;
      if (!isUnmountingRef.current) {
        autoStartTokenRef.current = autoStartTokenLocal;
      }

      saveRefForGUITest(autoStartTokenLocal);
      if (isTestEnvironment) {
        dispatch(bankIdAutostartTokenChangenAction(autoStartTokenLocal));
      }
      logger.debug('**** Got autostarttoken: ', autoStartTokenLocal);
      const appUrlLocal = getBankIdAppUrl(autoStartTokenLocal);
      logger.debug('**** Got appUrl: ', appUrlLocal);
      !isUnmountingRef.current && setAppUrl(appUrlLocal);
      !isUnmountingRef.current && setQrCode(qrDataLocal);
    } catch (error) {
      logger.info('Error, could not get autostarttoken. Error was ', error);
      if (svs.core.detect.feature('ft-bankid-secure-start')) {
        await handleShowErrorNoFlash();
        navigateToCancelUrl();
      } else {
        handleShowError(navigateToCancelUrl);
      }
      throw error;
    }
  };

  const checkBankIdLoginStatusAsync = async () => {
    logger.debug('**** In checkBankIdLoginStatusAsync: ', autoStartTokenRef.current);
    if (autoStartTokenRef.current) {
      try {
        const response = await pollCustomerLoginAsync(autoStartTokenRef.current);
        setQrCode(response.qrData);
        logger.debug('**** Got bankIdStatus: ', response);
        return response;
      } catch (error) {
        logger.info('Error, could not get checkBankIdLoginStatus. Error was ', error);
        return {
          progressStatus: -1,
          error
        };
      }
    } else {
      return {
        progressStatus: 0
      };
    }
  };

  const startTimeOutPoll = () => setTimeout(() => {
    const pollWithHandling = async () => {
      try {
        if (document.visibilityState === 'visible') {
          await pollContinuousBackend();
          logger.debug('### visible polling');
        } else {
          logger.debug('### hidden no polling');
          startTimeOutPoll();
        }
      } catch (error) {
        logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', error);
        if (svs.core.detect.feature('ft-bankid-secure-start')) {
          await handleShowErrorNoFlash();
          navigateToCancelUrl();
        } else {
          handleShowError(navigateToCancelUrl);
        }
      }
    };
    pollWithHandling();
  }, 1000);

  const handleReturnWhenError = async errorCode => {
    if (svs.core.detect.feature('ft-bankid-secure-start') && !isBankidOnThisDevice && !svs.core.detect.formfactor.mobile()) {
      await handleShowErrorNoFlash();
      navigateToCancelUrl();
    } else if (svs.core.detect.feature('ft-bankid-secure-start') && isBankidOnThisDevice) {
      await handleShowErrorNoFlash();
      dispatch(setIsBankidOnThisDevice(false));
    } else {
      handleShowBankIdErrorCode(errorCode, isSameDevice);
    }
    const routeToPush = isLogin ? route.LOGIN_BANKID_START_ROUTE : route.REGISTRATE_BANKID_ROUTE;
    history.push(routeToPush);
  };
  const handlePollError = async error => {
    logger.debug('BankIdQrCode: checkStatusChange got progressStatus -1 error: ', error);
    if (error.code === 56 && isQrCode && qrCodeRetries.current > 1) {
      qrCodeRetries.current = qrCodeRetries.current - 1;
      logger.debug("Generating new QR-code, retries left ".concat(qrCodeRetries.current));
      await initBankIdcodeAsync();
      timeOutRef.current = setTimeout(() => {
        const pollWithHandling = async () => {
          try {
            await pollContinuousBackend();
          } catch (pollError) {
            logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', pollError);
          }
        };
        pollWithHandling();
      }, 500);
    } else if (networkRetries.current > 0) {
      networkRetries.current = networkRetries.current - 1;
      timeOutRef.current = startTimeOutPoll();
      logger.info("Received network error: ".concat(error.code, ", retrying"));
    } else {
      logger.info('checkStatusChange got error: ', error);
      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: 'bankid',
        opt_value: error.code || 665
      });
      dispatch(bankIdAutostartTokenChangenAction(''));
      handleReturnWhenError(error.code);
    }
  };
  const handleRetailCustomer = (response, progressStatus) => {
    logger.debug('checkStatusChange run: progressStatus === 20 or 21');
    response.deviceId = undefined;
    response.requestId = undefined;
    response.requestInfo = undefined;
    response.eid = 'bankid';
    if (isReturnNewCustomer) {
      svs.components.Storage.browser.remove('returnUrl', 'player-login', () => {});
      response.returnUrl = returnUrl;
    }
    const newCustomerEvent = {
      category: 'Users',
      action: 'Customer Registration'
    };
    let customerType = '';
    if (progressStatus === bankidProgressStatus.NEW_CUSTOMER) {
      newCustomerEvent.opt_label = 'started_new_customer_from_bankid';
      customerType = 'new';
    } else {
      newCustomerEvent.opt_label = 'started_retail_customer_from_bankid';
      customerType = 'retail';
    }
    svs.components.analytics.trackEvent(newCustomerEvent, () => {
      storeCustomerType(customerType, () => {
        svs.utils.form.postToUrl(svs.core.urlMapping.get('customerRegistrationCompletion'), response, 'POST');
      });
    });
  };

  const pollContinuousBackend = React.useCallback(async () => {
    if (isUnmountingRef.current) {
      logger.debug("*** pollContinuousBackend - isUnmountingRef: ".concat(isUnmountingRef.current));
    } else {
      logger.debug("*** pollContinuousBackend - autoStartToken: ".concat(autoStartTokenRef.current));
      const response = await checkBankIdLoginStatusAsync();
      logger.debug('*** pollContinuousBackend - response');
      logger.debug(response);
      const {
        progressStatus,
        session,
        error
      } = response;
      if (session) {
        setBackendStatus(bankidProgressStatus.ONLINE_CUSTOMER);
        await checkPlayerAfterSessionAsync(isBankId, response, isQrCode, isSsn);
        return;
      }
      setBackendStatus(progressStatus);
      logger.debug(progressStatus);
      if (progressStatus < 6 && progressStatus > 0 && !session && !isUnmountingRef.current) {
        timeOutRef.current = startTimeOutPoll();
      } else {
        switch (progressStatus) {
          case bankidProgressStatus.ONLINE_CUSTOMER:
            checkPlayerAfterSessionAsync(isBankId, response, isQrCode, isSsn);
            break;
          case bankidProgressStatus.NEW_CUSTOMER:
          case bankidProgressStatus.RETAIL_CUSTOMER:
            handleRetailCustomer(response, progressStatus);
            break;
          case bankidProgressStatus.ERROR_POLL:
            handlePollError(error);
            break;
          default:
            logger.info('checkBankIdStatusChange invalid state', progressStatus);
        }
      }
    }
  }, [history, isLogin, isQrCode, isSameDevice, isSsn, useCheckPlayerAfterSession, document.visibilityState]);

  const cancelBackendPoll = async () => {
    logger.debug('*** function cancelBackendPoll...');
    timeOutRef.current && clearTimeout(timeOutRef.current);
    isUnmountingRef.current = true;
    if (autoStartTokenRef.current && autoStartTokenRef.current.length > 10) {
      dispatch(bankIdAutostartTokenChangenAction(''));
      await cancelCustomerLoginAsync(autoStartTokenRef.current);
      autoStartTokenRef.current = '';
    }
  };

  const getStartBankId = React.useCallback(async () => {
    logger.debug('*** init useBankIdPollStatus-async useEffect');
    try {
      if (!autoStartToken) {
        logger.debug('*** initBankIdcodeAsync');
        await initBankIdcodeAsync();
      } else {
        autoStartTokenRef.current = autoStartToken;
      }
      logger.debug('*** pollBackend');

      timeOutRef.current = setTimeout(() => {
        const pollWithHandling = async () => {
          try {
            await pollContinuousBackend();
          } catch (error) {
            logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', error);
            if (svs.core.detect.feature('ft-bankid-secure-start')) {
              await handleShowErrorNoFlash();
              navigateToCancelUrl();
            } else {
              handleShowError(navigateToCancelUrl);
            }
          }
        };
        pollWithHandling();
      }, 500);
      logger.debug('*** after pollBackend');
    } catch (error) {
      logger.debug("useBankIdPollStatus error:".concat(error));
      if (svs.core.detect.feature('ft-bankid-secure-start')) {
        await handleShowErrorNoFlash();
        navigateToCancelUrl();
      } else {
        handleShowError(navigateToCancelUrl);
      }
    }
  }, [pollContinuousBackend, autoStartToken]);

  React.useEffect(() => {
    logger.debug('*** init useBankIdPollStatus-useEffect');
    getStartBankId();
    return () => {
      logger.debug('*** end polling, unmounting...');
      isUnmountingRef.current = true;
      timeOutRef.current && clearTimeout(timeOutRef.current);
      if (!svs.core.detect.formfactor.mobile()) {
        logger.debug('*** end polling, calling cancelBackendPoll...');
        cancelBackendPoll();
      }
    };
  }, []);
  return {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll
  };
};
svs.playerLogin.bankid.useBankIdPollStatus = useBankIdPollStatus;

 })(window);